import React, { useState } from "react";
import Button from "../../../forms/Button";

const DeleteAccount = () => {
  const [isDeleteAccount, setDeleteAccount] = useState(false);
  return (
    <>
      <div className="relative bg-white py-4 px-4 shadow shadow-md-pink/20 rounded-lg">
        <div className="flex flex-col sm:flex-row items-start justify-between gap-4">
          <div className="w-full max-w-2xl space-y-1">
            <div className="text-lg 2xl:text-xl text-md-dark font-semibold">Delete account</div>
            <div className="text-sm text-slate-500 tracking-wide">Permanently delete your account and all associated data. This action cannot be undone.</div>
          </div>
          <div className="ml-auto flex-shrink-0 flex items-center gap-1">
            {isDeleteAccount ? (
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-regular fa-fw fa-xmark"}
                buttonIconPosition={"left"}
                buttonLabel={"Cancel"}
                buttonClasses={"!h-auto !rounded !px-2 !py-1 !text-md-pink !bg-transparent hover:!bg-md-pink/10 !gap-1"}
                buttonLabelClasses={"!font-semibold !text-md-dark !text-sm"}
                buttonFunction={() => setDeleteAccount(false)}
              />
            ) : (
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-regular fa-fw fa-trash-alt"}
                buttonIconPosition={"left"}
                buttonLabel={"Delete account"}
                buttonClasses={"!h-auto !rounded !px-2 !py-1 !text-md-pink !bg-transparent hover:!bg-md-pink/10 !gap-1"}
                buttonLabelClasses={"!font-semibold !text-md-dark !text-sm"}
                buttonFunction={() => setDeleteAccount(true)}
              />
            )}
          </div>
        </div>
        {isDeleteAccount && (
          <div className="mt-4 pt-4 border-t border-md-pink-light-1 flex items-end gap-4">
            <div className="flex-shrink flex-grow space-y-1 max-w-xl">
              <div className="text-lg 2xl:text-xl text-md-pink font-semibold">Are you sure you want to delete your account?</div>
              <div className="text-sm text-slate-500 tracking-wide">No longer want to use our service? You can delete your account here. This action is not reversible. All information related to this account will be deleted permanently.</div>
              <div className="flex flex-col flex-shrink-0 gap-2 !mt-6">
                <Button
                  buttonHasLink={false}
                  buttonIcon={"fa-regular fa-fw fa-recycle"}
                  buttonIconPosition={"left"}
                  buttonLabel={"No, Keep my account"}
                  buttonClasses={"!h-10 !rounded-md !px-3 !bg-md-pink-light-2 border border-md-pink-light-1 !text-md-pink hover:!bg-md-pink-light-1 hover:border-md-pink/20"}
                  buttonLabelClasses={"!font-medium !pb-1 !leading-none"}
                  buttonFunction={() => { }}
                />
                <Button buttonHasLink={false} buttonIcon={"fa-regular fa-fw fa-trash-alt"} buttonIconPosition={"left"} buttonLabel={"Yes, Delete my account"} buttonClasses={"!h-10 !rounded-md !px-3"} buttonLabelClasses={"!font-medium !pb-1 !leading-none"} buttonFunction={() => { }} />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DeleteAccount;
